import BaggageFlow from "@/components/Exercises/Baggage/BaggageFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import baggageIntroAudio from "@/assets/audios/baggage-exercise/BaggageAdultExerciseIntro.m4a";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/baggage/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Baggage Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "baggage.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="common.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="baggage.intro" />
      </p>
      <MediaPlayer src={baggageIntroAudio} isPaused={isPausedAudio} />
      <BaggageFlow
        isShow={showOverlay}
        onComplete={closeOverlay}
        onExit={closeOverlay}
      />
    </ExerciseLayout>
  );
}
